import parse from "html-react-parser";
import { Accordion } from "@asosteam/asos-web-component-library-accordion";
import { useDrawDetails } from "../../context/draw-details";
import styles from "./styles";
import global from "../../styles";

const FaqAccordion = () => {
  const [state] = useDrawDetails();
  const { howItWorks, faq, productInformation, termsAndConditions } =
    state.content;

  const scrollToItem = (previousItem, event) => {
    const { target } = event;

    previousItem.scrollIntoView({
      behavior: "smooth",
    });

    target.removeEventListener("transitionend", scrollToItem);
  };

  const scrollCloseToFaqItemContent = (eventTarget, itemClicked, openState) => {
    const accordionItem = eventTarget.closest("li");
    const previousListItem =
      eventTarget.closest("li").previousSibling || eventTarget.closest("div");

    if (openState) {
      accordionItem.addEventListener(
        "transitionend",
        scrollToItem.bind(null, previousListItem),
        {
          once: true,
        }
      );
    }
  };

  const renderAccordionContent = () => {
    const renderFaqs = () => {
      return (
        <div className={styles.faqs}>
          <h2 className={global.london2}>FAQs</h2>
          {faq &&
            faq.map(({ heading, text }) => (
              <div className={styles.faqItem} key={heading}>
                <h3 className={global.london4}>{heading}</h3>
                <p>{parse(text)}</p>
              </div>
            ))}
        </div>
      );
    };

    const renderHowItWorksSteps = () => {
      return (
        <>
          <div className={styles.howItWorks}>
            {howItWorks &&
              howItWorks.map((step) => (
                <div className={styles.step} key={step.heading}>
                  <h3 className={global.barnsley4}>{step.heading}.</h3>
                  <p>{parse(step.text)}</p>
                </div>
              ))}
          </div>
          {renderFaqs()}
        </>
      );
    };

    const renderTcsAndCs = () => {
      return (
        <>
          <div className={styles.tcsandcs}>
            {parse(termsAndConditions.summary || "")}
            <p>
              By entering the draw you’re agreeing to these{" "}
              <a href={termsAndConditions.linkUrl}>Ts&Cs</a>
            </p>
          </div>
        </>
      );
    };

    const items = [
      {
        content: renderHowItWorksSteps(),
        contentId: "howItWorks",
        title: "How it Works",
      },
      {
        content: parse(productInformation || ""),
        contentId: "productInfo",
        title: "Product Information",
      },
      {
        content: renderTcsAndCs(),
        contentId: "tsAndCs",
        title: "Terms & Conditions",
      },
    ];
    return items;
  };

  return (
    <div className={styles.wrapper}>
      <Accordion
        classname={`${styles.content} ${global.leavesden3}`}
        items={renderAccordionContent()}
        openIndexOnMount={0}
        headingElement="h2"
        onItemClick={scrollCloseToFaqItemContent}
      />
    </div>
  );
};

export default FaqAccordion;
